import clsx from "clsx";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { colors } from "../../../../ui/colors";
import { PlusIcon } from "../../../../ui/icons/plus";
import { PersonDTO } from "../../../database/people/dto";
import { ContactStateEnum } from "../../dto";
import { LeadTakenPrivacyNotVerified } from "./notVerified";
import { LeadTakenPrivacyVerified } from "./privacyVerified";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    listIndex: number;
    isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
    person: PersonDTO
}

export function LeadTakenModal({ isOpen, onClose, listIndex, isLoading, handleConfirm, person }: Props) {
    useEffect(() => {
        const handleEscKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        };
    }, []);

    return createPortal(
        <div
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
            }}
            className={clsx(
                "transition-all fixed bg-opacity-30 z-[50] bg-neutral-950 backdrop-blur-sm top-0 left-0 right-0 bottom-0 h-full w-full flex items-center justify-center",
                {
                    block: isOpen,
                    hidden: !isOpen,
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                className="transition-all relative bg-white rounded-[12px] opacity-100 shadow-sm min-w-[600px]"
            >
                <div
                    onClick={() => onClose()}
                    className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                >
                    <PlusIcon color={colors.brandPrimary[600]} size={16} />
                </div>
                <div className="p-6 text-heading-xs font-semibold text-center">
                    Prendi in lead il contatto
                </div>
                <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
                    {
                        person?.privacy ? (
                            <LeadTakenPrivacyVerified person={person!} isLoading={isLoading} handleConfirm={handleConfirm} onClose={onClose} listIndex={listIndex} />
                        ) : (
                            <LeadTakenPrivacyNotVerified isOpen={isOpen} onClose={onClose} listIndex={listIndex} isLoading={isLoading} handleConfirm={handleConfirm} person={person} />
                        )
                    }
                </div>
            </div>
        </div>,
        document.body
    )
}